const PREFIX = '[Storage]';

const Storage = {
  getItem(key) {
    if (!localStorage) return undefined;

    return localStorage.getItem(key);
  },
  removeItem(key) {
    if (!localStorage) return;

    localStorage.removeItem(key);
  },
  setItem(key, value) {
    console.log(`${PREFIX} setting ${key}, value: ${JSON.stringify(value)}`);
    if (!localStorage) {
      console.log(`${PREFIX} NOT available`);
      return;
    }

    try {
      localStorage.setItem(key, value);
    } catch (e) {
      console.log(`${PREFIX} setItem error: ${e.message}`);
    }
  },
  setMtmUserToken(tokenPayload) {
    this.setToken('MTM_USER_TOKEN', tokenPayload);
  },
  getMtmUserToken() {
    return this.getToken('MTM_USER_TOKEN');
  },
  removeMtmUserToken() {
    this.removeToken('MTM_USER_TOKEN');
  },
  setUserToken(tokenPayload) {
    this.setToken('USER_TOKEN', tokenPayload);
  },
  getUserToken() {
    return this.getToken('USER_TOKEN');
  },
  removeUserToken() {
    this.removeToken('USER_TOKEN');
  },
  setMtmUserAuth(auth) {
    this.setItem('MTM_USER_AUTH', JSON.stringify(auth));
  },
  getMtmUserAuth() {
    return JSON.parse(this.getItem('MTM_USER_AUTH')) || {};
  },
  removeMtmUserAuth() {
    this.removeItem('MTM_USER_AUTH');
  },
  setToken(namespace, { token, expiredIn = 0 }) {
    const timestamp = expiredIn * 1000 + Date.now();
    console.log('access token expiry timestamp', timestamp);
    this.setItem(namespace, JSON.stringify({ token, timestamp }));
  },
  getToken(namespace) {
    const payload = this.getItem(namespace) || {};
    // for backward compatibility
    const { token = '', timestamp } = typeof payload === 'string' ? { token: payload } : {};
    if (Date.now() >= timestamp) {
      console.log('stored access token has expired: ', namespace, timestamp);
      return '';
    }
    return token;
  },
  removeToken(namespace) {
    this.removeItem(namespace);
  },
  setUserAuth(auth) {
    this.setItem('USER_AUTH', JSON.stringify(auth));
  },
  getUserAuth() {
    return JSON.parse(this.getItem('USER_AUTH')) || {};
  },
  removeUserAuth() {
    this.removeItem('USER_AUTH');
  },
  setAgreementAccepted() {
    this.setItem('AGREEMENT', true);
  },
  getAgreementAccepted() {
    return JSON.parse(this.getItem('AGREEMENT')) || false;
  },
  setCountryCode(code) {
    this.setItem('COUNTRY_CODE', JSON.stringify(code));
  },
  getCountryCode() {
    return JSON.parse(this.getItem('COUNTRY_CODE') || 'null');
  },
  setStoreConfigs(configs) {
    this.setItem('STORE_CONFIGS', JSON.stringify(configs));
  },
  getStoreConfigs() {
    return JSON.parse(this.getItem('STORE_CONFIGS')) || null;
  },
  removeStoreConfigs() {
    this.removeItem('STORE_CONFIGS');
  },
  setMeasuringSystem(system) {
    this.setItem('MEASURING_SYSTEM', system);
  },
  getMeasuringSystem() {
    return this.getItem('MEASURING_SYSTEM') || 'metric';
  },
};

export default Storage;
